import axios from "axios";
import { message as AntdAlert } from "antd";
import { put, select } from "redux-saga/effects";
import * as actions from "../actions";
import { baseURL } from "../../../../globalUtils/axiosConfig";
import { errorHandler } from "../../../../components/unauthorizeHandler";

export function* handleCreateProject({ data }) {

  try {
    const fd = new FormData();
    for (const [key, value] of Object.entries(data)) {
      if (key === "documents" && value !== undefined) {
        if (Array.isArray(value)) {
          value.forEach(file => {
            fd.append('documents', file);
          });
        } else if (value) {
          fd.append('documents', value);
        }
        continue;
      }
      
      if (value && value._isAMomentObject) {
        fd.append(key, value.format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z');
      }
      else if (value !== null && value !== undefined) {
        fd.append(key, value);
      }
    }
    for (const pair of fd.entries()) {
      if (pair[1] instanceof File) {
        console.log(`${pair[0]}: File - ${pair[1].name} (${pair[1].type}, ${pair[1].size} bytes)`);
      } else {
        console.log(`${pair[0]}: ${pair[1]}`);
      }
    }
    
    const response = yield axios.post(`${baseURL}/project`, fd, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });
    
    if (response.status === 201) {
      AntdAlert.success("Project created successfully");
      yield put(actions.createProjectSuccess(response.data));
    } else if (response.status !== 201) {
      AntdAlert.error("Something went wrong!");
      yield put(actions.createProjectError());
      errorHandler(response.data);
    }
  } catch (error) {
    console.log(error);
    yield put(actions.createProjectError());
  }
}

export function* handleUpdateProject({ data }) {
  console.log("handleUpdateProject", data);
  
  try {
    const projectId = data.id;
    const formData = new FormData();
    
    for (const [key, value] of Object.entries(data)) {
      if (key === "id") {
        continue;
      }
      else if (key === "documents") {
        if (value && Array.isArray(value)) {
          value.forEach(file => {
            if (file.isLocal) {
              formData.append('documents', file);
            }
          });
        }
      }
      else if (value && value._isAMomentObject) {
        formData.append(key, value.format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z');
      } 
      else if (key === 'startDate' || key === 'endDate') {
        if (value && typeof value === 'string') {
          formData.append(key, new Date(value).toISOString());
        } else if (value) {
          formData.append(key, value);
        }
      }
      else if (key === 'deliveryNotesNotificationsRecipients') {
        if (Array.isArray(value)) {
          if (value.length === 0) {
            formData.append(key, '[]');
          } else {
            value.forEach((recipient, index) => {
              formData.append(`${key}[${index}][full_name]`, recipient.full_name);
              formData.append(`${key}[${index}][email]`, recipient.email);
              if (recipient.designation) {
                formData.append(`${key}[${index}][designation]`, recipient.designation);
              }
            });
          }
        }
      }
      else if (value !== null && value !== undefined) {
        formData.append(key, value);
      }
    }
        
    const response = yield axios.patch(
      `${baseURL}/project/${projectId}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    if (response.status === 200) {
      AntdAlert.success("Project updated successfully");
      yield put(actions.updateProjectSuccess(response.data));
    } else if (response.status !== 200) {
      AntdAlert.error("Something went wrong!");
      yield put(actions.updateProjectError());
      errorHandler(response.data);
    }
  } catch (error) {
    console.log(error);
    yield put(actions.updateProjectError());
  }
}

export function* handleFetchProjectDetailsUtils() {
  try {
    const response = yield axios.get(`${baseURL}/api/v1/users/user_details`);
    const { success } = response.data;

    if (success) {
      yield put(actions.fetchProjectDetailsUtilsSuccess(response.data.data));
    }
    errorHandler(response.data);
  } catch (error) {
    console.log(error);
  }
}

export function* handleFetchAllProjects({ data }) {
  const { search, ...rest } = data;
  Object.keys(search).forEach((key) => {
    if (search[key]?.length < 1 || search[key] === null) delete search[key];
  });
  
  if (search && search.status) {
    search.projectStatusId = search.status;
    delete search.status;
  }
  
  try {
    const response = yield axios.get(`${baseURL}/project`, {
      params: {
        ...rest,
        ...(Object.keys(search).length > 0 && {
          ...search,
          // showByDefault: false,
        }),
      },
    });


    if (response.status === 200) {
      yield put(actions.fetchAllProjectsSuccess(response.data));
    } else if (response.status !== 200) {
      errorHandler(response.data);
      yield put(actions.fetchAllProjectsError(response.data));
    }
  } catch ({ response }) {
    yield put(actions.fetchAllProjectsError(response.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleDeleteProject({ data }) {
  try {
    const response = yield axios.delete(
      `${baseURL}/project/${data.id}`
    );
    if (response.status === 200) {
      AntdAlert.success("Project deleted successfully");
      yield put(actions.deleteProjectSuccess(response.data));
    } else if (response.status !== 200) {
      errorHandler(response.data);
      yield put(actions.deleteProjectError(response.data));
    }
  } catch ({ response }) {
    yield put(actions.deleteProjectError(response.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleFetchProject({ data }) {
  try {
    const response = yield axios.get(`${baseURL}/project/${data}`);

    if (response.status === 200) {
      // const { permissions, ...res } = response.data.data;
      yield put(actions.fetchProjectSuccess(response.data));
    } else {
      yield put(actions.updateProjectError());
      errorHandler(response.data);
    }
  } catch (error) {
    console.log(error);
  }
}

export function* handleDeleteProjectAttach({ data }) {
  try {
    const { projectId, attachmentId } = data;
    
    if (!projectId) {
      AntdAlert.error("Project ID not found. Cannot delete attachment.");
      yield put(actions.deleteProjectAttachError({ error: "Project ID not found" }));
      return;
    }
    
    const response = yield axios.delete(
      `${baseURL}/attachments/${attachmentId}`
    );

    
    if (response.status === 200) {
      AntdAlert.success("Attachment deleted successfully");
      yield put(actions.deleteProjectAttachSuccess(response.data.data));
    } else if (response.status !== 200) {
      errorHandler(response.data);
      yield put(actions.deleteProjectAttachError(response.data.data));
    }
  } catch ({ response }) {
    yield put(actions.deleteProjectAttachError(response.data.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

// Project Priority API Handlers
export function* handleFetchProjectPriorities({ data }) {
  try {
    const projectId = data;
    
    if (!projectId) {
      AntdAlert.error("Project ID not found. Cannot fetch priorities.");
      yield put(actions.fetchProjectPrioritiesError("Project ID not found"));
      return;
    }
    
    const response = yield axios.get(`${baseURL}/project-priority?projectId=${projectId}`);
    
    if (response.status === 200) {
      yield put(actions.fetchProjectPrioritiesSuccess(response.data));
    } else {
      errorHandler(response.data);
      yield put(actions.fetchProjectPrioritiesError("Failed to fetch priorities"));
    }
  } catch (error) {
    console.error("Error fetching project priorities:", error);
    yield put(actions.fetchProjectPrioritiesError(error.message));
    AntdAlert.error("Failed to load project priorities");
  }
}

export function* handleCreateProjectPriority({ data }) {
  try {
    const { name, color, position, projectId } = data;
    
    if (!projectId) {
      AntdAlert.error("Project ID not found. Cannot create priority.");
      yield put(actions.createProjectPriorityError("Project ID not found"));
      return;
    }
    
    const response = yield axios.post(`${baseURL}/project-priority`, {
      name,
      color,
      position,
      projectId
    });
    
    if (response.status === 201) {
      AntdAlert.success("Priority created successfully");
      yield put(actions.createProjectPrioritySuccess(response.data));
      // Refresh priorities list
      yield put(actions.fetchProjectPriorities(projectId));
    } else {
      errorHandler(response.data);
      yield put(actions.createProjectPriorityError("Failed to create priority"));
    }
  } catch (error) {
    console.error("Error creating project priority:", error);
    yield put(actions.createProjectPriorityError(error.message));
    AntdAlert.error("Failed to create priority");
  }
}

export function* handleUpdateProjectPriority({ data }) {
  try {
    const { id, name, color, position } = data;
    
    if (!id) {
      AntdAlert.error("Priority ID not found. Cannot update priority.");
      yield put(actions.updateProjectPriorityError("Priority ID not found"));
      return;
    }
    
    const response = yield axios.patch(`${baseURL}/project-priority/${id}`, {
      name,
      color,
      position
    });
    
    if (response.status === 200) {
      AntdAlert.success("Priority updated successfully");
      yield put(actions.updateProjectPrioritySuccess(response.data));
    } else {
      errorHandler(response.data);
      yield put(actions.updateProjectPriorityError("Failed to update priority"));
    }
  } catch (error) {
    console.error("Error updating project priority:", error);
    yield put(actions.updateProjectPriorityError(error.message));
    AntdAlert.error("Failed to update priority");
  }
}

export function* handleDeleteProjectPriority({ data }) {
  try {
    const priorityId = data;
    
    if (!priorityId) {
      AntdAlert.error("Priority ID not found. Cannot delete priority.");
      yield put(actions.deleteProjectPriorityError("Priority ID not found"));
      return;
    }
    
    const response = yield axios.delete(`${baseURL}/project-priority/${priorityId}`);
    
    if (response.status === 200) {
      AntdAlert.success("Priority deleted successfully");
      yield put(actions.deleteProjectPrioritySuccess(response.data));
    } else {
      errorHandler(response.data);
      yield put(actions.deleteProjectPriorityError("Failed to delete priority"));
    }
  } catch (error) {
    console.error("Error deleting project priority:", error);
    yield put(actions.deleteProjectPriorityError(error.message));
    AntdAlert.error("Failed to delete priority");
  }
}

export function* handleSortProjectPriorities({ data }) {
  try {
    const response = yield axios.post(`${baseURL}/project-priority/sort`, {
      projectPriority: data.priorityOrder
    });
    
    if (response.status === 200) {
      AntdAlert.success("Priorities sorted successfully");
      yield put(actions.sortProjectPrioritiesSuccess(response.data));
      // Refresh priorities list
      if (data.projectId) {
        yield put(actions.fetchProjectPriorities(data.projectId));
      }
    } else {
      errorHandler(response.data);
      yield put(actions.sortProjectPrioritiesError("Failed to sort priorities"));
    }
  } catch (error) {
    console.error("Error sorting project priorities:", error);
    yield put(actions.sortProjectPrioritiesError(error.message));
    AntdAlert.error("Failed to sort priorities");
  }
}

export function* handleUpdateProjectNotifications({ data }) {
  try {
    const fd = new FormData();
    for (const [key, value] of Object.entries(data)) {
      if (value !== null && value !== undefined) {
        fd.append(key, value);
      }
    }
    const response = yield axios.put(
      `${baseURL}/api/v1/projects/${data.id}`,
      fd,
      {
        headers: {
          "content-type": "multipart/form-data",
        },
      }
    );
    const { success, message } = response.data;
    if (success) {
      AntdAlert.success(message);
      yield put(actions.updateProjectNotificationsSuccess(response.data.data));
    } else if (!success) {
      AntdAlert.error(response.data?.errors[0]);
      yield put(actions.updateProjectNotificationsError());
      errorHandler(response.data);
    }
  } catch (error) {
    console.log(error);
  }
}
